import React, { Suspense } from "react";
import { Route, Switch, useHistory, useLocation, useParams, useRouteMatch } from "react-router-dom";
import { useCurrentTenant } from "@qpr/client-library/dist/esm";
import { useAppContext } from "qpr-base/context/AppCtxProvider";
import useRanges from "qpr-base/hooks/useRangeContext";
import Loader from "qpr-base/ui/components/Loader";
import SubViews from "./SubViews";
import { useRoutingGuards } from "./hooks/useRoutingGuards";
import { useInitContextFromUrlAndSession } from "./hooks/useInitContextFromUrlAndSession";

const LandingPage = React.lazy(() => import("../../pages/landingpage/index"));

const RoutesContainer = () => {
  const { path } = useRouteMatch();
  const tenant = useCurrentTenant();
  const ctx = useAppContext();
  const history = useHistory();
  const location = useLocation();
  const params = useParams<{
    id: string;
    meaId: string;
    period: string;
    model: string;
    module: string;
  }>();

  useRoutingGuards({
    tenantSymbol: tenant.symbol,
    ctx,
    params,
    location,
    history,
  });

  useInitContextFromUrlAndSession({
    tenantSymbol: tenant.symbol,
    ctx,
    params,
    location,
  });

  useRanges();

  return (
    <Suspense fallback={<Loader />}>
      <Switch>
        <Route path={`/${tenant.symbol}/`} exact component={LandingPage} />
        <Route path={`/${tenant.symbol}/:model/`} exact component={LandingPage} />
        <Route path={`${path}/`} component={LandingPage} exact />
        <Route path={`/${tenant.symbol}/${ctx.modelId}/landingpage/:meaId?/`} component={LandingPage} />
        <Route path={`${path}/:model/:id/:meaId?/`} component={SubViews} />
      </Switch>
    </Suspense>
  );
};

export default RoutesContainer;

